/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import * as React from 'react';
import { IInstagramIntegrationViewProps } from './instagram-integration';

/**
 * Loads a Wayin script that embeds Instagram images for a configurable API Token
 */
export class InstagramIntegrationView extends React.PureComponent<IInstagramIntegrationViewProps, { value: string }> {

    public constructor(props: IInstagramIntegrationViewProps) {
        super(props);
    }

    public render(): JSX.Element | null {
        return (
            // tslint:disable-next-line: react-iframe-missing-sandbox
            <iframe
                src={`https://us-display.wayin.com/display/container/dc/${this.props.config.token}?mode=responsive`}
                frameBorder='0'
                scrolling='no'
                width={`${this.props.config.width}`}
                height={`${this.props.config.height}`}
                id={`ngxFrame${this.props.config.token}`}
            />
        );
    }
}

export default InstagramIntegrationView;